<template>
  <div v-if="messageId || errorId" class="mt-10 mb-15 message-container">
    <button type="button" class="delete btn-delete" @click="clearMessage" />
    <b-message v-if="messageId && !errorId" class="is-info">
      {{ $t(messageId) }}
    </b-message>
    <b-message v-if="errorId" class="is-danger"> {{ $t(errorId) }} </b-message>
  </div>
</template>

<script>
export default {
  name: 'MessageArea',
  data() {
    return {
      // cMessageId: this.messageId,
      // cErrorId: this.errorId
    };
  },
  computed: {
    messageId: function() {
      return this.$store.state.messageId.successState;
    },
    errorId: function() {
      return this.$store.state.messageId.errorState;
    }
  },
  watch: {
    messageId: function(value) {
      // console.log(7777777, value)
      // this.cMessageId = value;
    },
    errorId: function(value) {
      // console.log(88888888888, value)
      // this.cErrorId = value;
    }
  },
  methods: {
    clearMessage() {
      // this.cMessageId = null;
      this.$store.commit('messageId/updateMessageIdErrorState', null);
      this.$store.commit('messageId/updateMessageIdSuccesState', null);
      // this.cErrorId = null;
      // // this.messageId = null;
      // // this.errorId = null;
      // this.$emit('update:errorId', null);
      // this.$emit('showMessage', callback);
    }
  }
};
</script>

<style lang="scss" src="./message-area.scss" scoped>
</style>
